import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UserDTO } from 'types/user';

export type UserState = Readonly<{
  user: UserDTO | null;
}>;

export const initialState: UserState = { user: null };

const userSlice = createSlice({
  name: 'User',
  initialState,
  reducers: {
    updateUser: (state, action: PayloadAction<UserDTO | null>) => {
      state.user = action.payload;
    },
  },
});

export const { updateUser } = userSlice.actions;
export default userSlice.reducer;
